import * as React from "react"

import homeStyles from "../components/home.module.css";
import playImage from "../images/googleplay.png";
import iosImage from "../images/appstore.png";
import chirpiLogo from "../images/chirpi_logo.svg";

import homePageScreen from "../images/home_page.png";
import notificationsScreen from "../images/notifications.png";
import videoCallScreen from "../images/video_call.png";

const PLAY_STORE = "https://play.google.com/store/apps/details?id=com.chirpi";
const IOS_STORE = "https://apps.apple.com/us/app/chirpi/id1537502552";
const WEBSITE = "https://getchirpi.web.app/";
const PRIVACY_POLICY = "https://www.notion.so/Chirpi-Privacy-Policy-a62f069d6b5d41fb85e3f0021abb7aaa";

const IndexPage = () => {
  return (
    <main className={`${homeStyles.chirpi_font} ${homeStyles.no_padding}`}>
      <title>Chirpi | Spontaneous Virtual Interaction</title>
      <div className={homeStyles.top}>
        <div className={homeStyles.corner}>
          <a href={WEBSITE} className={homeStyles.logo_container}>
            <img src={chirpiLogo} alt={WEBSITE} className={homeStyles.logo} />
          </a>
          <h3 className={homeStyles.logo_slogan}>Chirpi</h3>
        </div>
        <div className={homeStyles.page}>
          <h1 className={homeStyles.title}>Bring Spontaneity Back Into Your Day</h1>
          <h3 className={homeStyles.subtitle}>Automatically call with friends when you're both taking a break</h3>
          <div className={homeStyles.row}>
            <a href={PLAY_STORE} target="_blank" rel="noreferrer">
              <img src={playImage} alt={PLAY_STORE} />
            </a>
            <a href={IOS_STORE} target="_blank" rel="noreferrer">
              <img src={iosImage} alt={IOS_STORE} />
            </a>
          </div>
        </div>
      </div>
      <div className={homeStyles.page}>
        <h3 className={homeStyles.section_start}>Remote everything can get lonely...</h3>
        <h3 className={`${homeStyles.subtitle} ${homeStyles.list_text}`}>Do you miss bumping into friends in the hallway?</h3>
        <h3 className={`${homeStyles.subtitle} ${homeStyles.list_text}`}>Or the impromptu chats before class?</h3>
        <h3 className={`${homeStyles.subtitle} ${homeStyles.list_text}`}>We wanted to help recreated these interactions, virutally.</h3>
      </div>
      <div className={`${homeStyles.page} ${homeStyles.top_divider}`}>
        <div className={homeStyles.section_row}>
          <div className={homeStyles.column}>
            <h3 className={homeStyles.bullet_start}>See who else is free to chat right now</h3>
            <h3 className={homeStyles.bullet}>Update your own status when you want to chat</h3>
            <h3 className={homeStyles.bullet}>No more worrying about interrupting someone</h3>
          </div>
          <img src={homePageScreen} alt="iPhone screen of app" className={homeStyles.promo_image} />
        </div>
        <div className={homeStyles.section_row}>
          <img src={videoCallScreen} alt="iPhone screen of app" className={homeStyles.promo_image} />
          <div className={homeStyles.column}>
            <h3 className={homeStyles.bullet_start}>Stay focused with short and casual chats throughout the day</h3>
            <h3 className={homeStyles.bullet}>Calls automatically end after 5 minutes</h3>
            <h3 className={homeStyles.bullet}>Feeling screen fatigue? Take a walk and switch to audio</h3>
          </div>
        </div>
        <div className={homeStyles.section_row}>
          <div className={homeStyles.column}>
            <h3 className={homeStyles.bullet_start}>Ask friends to take a break with you</h3>
            <h3 className={homeStyles.bullet}>Give them a wave and see if they're free</h3>
            <h3 className={homeStyles.bullet}>No more scheduling hassle to stay in touch with friends</h3>
          </div>
          <img src={notificationsScreen} alt="iPhone screen of app" className={homeStyles.promo_image} />
        </div>
      </div>
      <div className={homeStyles.banner}>
        <h3 className={homeStyles.banner_text}>If you're interested, try it out!</h3>
        <div className={homeStyles.row}>
          <a href={PLAY_STORE} target="_blank" rel="noreferrer">
            <img src={playImage} alt={PLAY_STORE} />
          </a>
          <a href={IOS_STORE} target="_blank" rel="noreferrer">
            <img src={iosImage} alt={IOS_STORE} />
          </a>
        </div>
      </div>
      <div className={homeStyles.footer}>
        <h4 className={homeStyles.info}>Contact: getchirpi@gmail.com</h4>
        <a href={PRIVACY_POLICY}>
          <h4 className={homeStyles.link}>Privacy Policy</h4>
        </a>
        <a href="https://www.videezy.com/people/53057-woman-talk-to-at-video-calling-recording">
          <h4 className={homeStyles.link}>Stock Image #1 For Video Provided By Videezy</h4>
        </a>
        <a href="https://www.videezy.com/people/47745-woman-waves-goodbye-to-video-call-from-smart-phone">
          <h4 className={homeStyles.link}>Stock Image #2 For Video Provided By Videezy</h4>
        </a>
        <p className={homeStyles.copyright}>Chirpi 2020.</p>
      </div>
    </main>
  );
};

export default IndexPage
